/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react'
import { LuHome, LuInfo, LuWarehouse, LuPenSquare, LuUser, LuLayoutDashboard, LuLogOut, LuHammer } from 'react-icons/lu'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import UserContext from '../../context/UserContext'
import logo from '../../assets/logo.jpeg'

function Drawer(props) {
    const userCtx = useContext(UserContext)
    const isAuth = userCtx.isAuth
    const user = userCtx.user
    const location = useLocation()
    const navigate = useNavigate()

    function logout() {
        userCtx.logout()
        navigate('/')
    }

    function handleUlClick(event) {
        if (event.target.closest('a')) {
            const drawerToggle = document.getElementById("nav-drawer")
            drawerToggle.click()
        }
    }

    function openModal() {
        const openBtn = document.getElementById("contact-modal-open-btn")
        openBtn.click()
    }

    const NavLink = ({ to, icon: Icon, children }) => (
        <li>
            <Link
                to={to}
                className={`
                    flex items-center gap-4 px-5 py-4 rounded-xl mb-1 transition-all duration-300
                    ${location.pathname === to
                        ? 'bg-primary/10 text-primary font-black shadow-sm'
                        : 'text-on-surface-variant hover:bg-surface-container hover:text-on-surface'}
                `}
            >
                <Icon size={20} className={location.pathname === to ? 'text-primary' : 'text-outline'} />
                <span className="text-sm uppercase tracking-widest font-bold">{children}</span>
            </Link>
        </li>
    )

    return (
        <div className="drawer-side z-[100]">
            <label htmlFor="nav-drawer" className="drawer-overlay  bg-black/20"></label>

            <div className="flex flex-col w-72 bg-white h-full border-r border-outline-variant/10 shadow-2xl">
 
                <div className="p-8 flex items-center justify-center border-b border-outline-variant/5">
                    <img src={logo} alt="logo" className="h-20 w-auto rounded-xl object-contain" />
                </div>

                <ul onClick={handleUlClick} className="flex-grow p-4 space-y-1">
                    <NavLink to="/" icon={LuHome}>Home</NavLink>
                    <NavLink to="/about" icon={LuInfo}>About</NavLink>
                    <NavLink to="/houses" icon={LuWarehouse}>Houses</NavLink>
                    <NavLink to="/blog" icon={LuPenSquare}>Blog</NavLink>

                    {isAuth && (
                        <>
                            <li className="pt-6 pb-2 px-6">
                                <span className="text-[10px] font-black uppercase tracking-[0.3em] text-outline">Account</span>
                            </li>
                            <NavLink to="/auth/profile" icon={LuUser}>Profile</NavLink>
                            {user?.is_superuser && (
                                <NavLink to="/auth/admin" icon={LuLayoutDashboard}>Admin</NavLink>
                            )}
                            <li>
                                <a
                                    onClick={logout}
                                    className="flex items-center gap-4 px-6 py-4 rounded-xl text-error hover:bg-error/5 transition-all cursor-pointer"
                                >
                                    <LuLogOut size={20} />
                                    <span className="text-sm uppercase tracking-widest font-black">Logout</span>
                                </a>
                            </li>
                        </>
                    )}
                </ul>

                <div className="p-6 border-t border-outline-variant/10 bg-surface-container-low/30">
                    <button
                        className="w-full bg-primary text-white flex items-center justify-center gap-3 py-4 rounded-2xl font-black text-[10px] uppercase tracking-[0.2em] shadow-lg shadow-primary/20 hover:shadow-primary/30 active:scale-95 transition-all"
                        onClick={openModal}
                    >
                        <LuHammer size={18} />
                        Custom Plan
                    </button>
                    <div className="mt-4 text-center">
                        <span className="text-[8px] font-black text-outline uppercase tracking-widest opacity-50">
                            Jahtech v4.2
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Drawer